import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LectionDiv } from '../component/lection/LectionDiv';
import { gteMd5Conspect } from '../utils/utils';
import { IApiResult } from '../interface/IApiResult';
import { apiCheckContentDto } from '../service/apiCheckContentDto';

interface Props {
  screenShot: number;
  selectThemeFromMain: number;
  selectPosition: number;
  onChange: (e: any) => void;
  onChange2: (e: any) => void;
  onChange5: (e: any) => void;
}

export const LectionPage: FunctionComponent<Props> = ({
  screenShot,
  selectThemeFromMain,
  selectPosition,
  onChange,
  onChange2,
  onChange5,
}) => {
  const [timestamp, setTimestamp] = useState(Math.floor(Date.now() / 1000));
  const getTimestamp = async () => {
    const apiResult: IApiResult = await apiCheckContentDto();
    if (apiResult.isSuccess) {
      setTimestamp(apiResult.data.timestamp);
    }
  };
  useEffect(() => {
    getTimestamp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { secureToken, apiVersion, accessToken, section, lectionId } =
    useParams();
  if (
    secureToken !== undefined &&
    apiVersion !== undefined &&
    accessToken !== undefined
  ) {
    if (parseInt(apiVersion, 10) < 16) {
      return <div> </div>;
    }
    const unixtTime = secureToken.substring(0, 10);
    const diff = timestamp - parseInt(unixtTime, 10);

    if (diff > 60) {
      return <div> </div>;
    }

    const toMd5 = `${unixtTime}nurlat${lectionId}${section}`;
    let md5Secure = gteMd5Conspect(toMd5);
    md5Secure = `${unixtTime}${md5Secure}`;

    if (md5Secure !== secureToken) {
      return <div> </div>;
    }
  }

  return (
    <LectionDiv
      isCesh={secureToken !== undefined}
      screenShot={screenShot}
      selectThemeFromMain={selectThemeFromMain}
      selectPosition={selectPosition}
      onChange={onChange}
      onChange2={onChange2}
      onChange5={onChange5}
    />
  );
};
